import Paho from 'paho-mqtt';

let client = null;

// host, port, clientId,
export const connectMQTT = (onMessageArrived, onConnect, onConnectionLost) => {

    // client = new Client(host, Number(port), clientId);

    let configs = JSON.parse(localStorage.getItem("configuration_data"));

    console.log("ip: ", configs['ip']);
    console.log("port: ", configs['port']);

    client = new Paho.Client(configs['ip'],
        Number(configs['port']),
        'mqttjs_' +
        Math.random()
            .toString(16)
            .substr(2, 8));

    console.log("client: ", client)

    client.onConnectionLost = onConnectionLost;
    client.onMessageArrived = onMessageArrived;

    client.connect({
        onSuccess: onConnect,
        onFailure: (err) => console.error('Connection failed', err),
        useSSL: configs['use-ssl'] === 'true',
        userName: configs['mq-username'],
        password: configs['mq-password'],
    });
};

export const onConnectionLost = (responseObject) => {
    if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:" + responseObject.errorMessage);
    }
}

export const subscribeTopic = (topic) => {
    if (client && client.isConnected()) {
        client.subscribe(topic);
        console.log(`Subscribed to ${topic}`);
    }
};

export const unsubscribeTopic = (topic) => {
    if (client && client.isConnected()) {
        client.unsubscribe(topic);
        console.log(`Unsubscribed from ${topic}`);
    }
};

export const disconnectMQTT = () => {
    if (client && client.isConnected()) {
        client.disconnect();
        console.log('Disconnected from MQTT broker');
    }
};

export const publishMessage = (topic, message) => {
    if (client && client.isConnected()) {
        const msg = new window.Paho.MQTT.Message(message);
        msg.destinationName = topic;
        client.send(msg);
    }
};
